import {
    Box,
    Card,
    CardContent,
    Typography,
    Chip,
    keyframes,
    CardActionArea,
} from "@mui/material";
import Icon from "../atoms/Icon";

interface TaskCardProps {
    title: string;
    description: string;
    taskCount: number;
    icon: string;
    color?: string;
}

// Define color pulse animation for the chip
const colorPulse = keyframes`
  0%, 100% {
    opacity: 1;
    filter: brightness(1);
  }
  50% {
    opacity: 0.8;
    filter: brightness(1.3);
  }
`;

const TaskCard = ({
    title,
    description,
    taskCount,
    icon,
    color = "#1976d2",
}: TaskCardProps) => (
    <Card
        sx={{
            cursor: taskCount === 0 ? "pointer" : "default",
            transition: "all 0.3s",
            "&:hover": taskCount > 0 ? {
                transform: "translateY(-4px)",
                boxShadow: 3,
            } : {},
            minHeight: 180,
            display: "flex",
            flexDirection: "column",
        }}
    >
        <CardActionArea sx={{ height: "100%" }} disabled={taskCount === 0}>
            <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Box
                        sx={{
                            backgroundColor: `${color}15`,
                            borderRadius: 2,
                            p: 1,
                            mr: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Icon name={icon} sx={{ color, fontSize: 28 }} />
                    </Box>
                    {(taskCount > -1) && (
                        <Chip
                            label={`${taskCount} ${taskCount === 1 ? "task" : "tasks"}`}
                            size="small"
                            sx={{
                                backgroundColor: taskCount > 0 ? color : "#9e9e9e",
                                color: "white",
                                fontWeight: "bold",
                                animation: taskCount > 0 ? `${colorPulse} 1.5s ease-in-out infinite` : "none",
                            }}
                        />
                    )}
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
                    {description}
                </Typography>
                {taskCount > 0 && (
                    <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                        <Typography variant="caption" sx={{ color, fontWeight: 500 }}>
                            View Tasks
                        </Typography>
                        <Icon name="ArrowForward" sx={{ fontSize: 16, ml: 0.5, color }} />
                    </Box>
                )}
            </CardContent>
        </CardActionArea>
    </Card>
);

export default TaskCard;
